import { values } from 'lodash';
import { BASE_ACTIONS, SAGA_ACTIONS } from 'modules/Taps/redux/ndfl3Saga/NDFL3SagaActionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

function buildReducersForTypicalRequests(state, action) {
  let resultState = state;
  values(BASE_ACTIONS).some((baseAction) => {
    if (action.type === baseAction.name + '.REQUEST_START') {
      resultState = {
        ...state,
        dictionaries: {
          ...state.dictionaries,
          [baseAction.path]: {
            loading: true,
            tried: true,
          },
        },
      };
      return true;
    } else if (action.type === baseAction.name + '.REQUEST_FAILURE') {
      resultState = {
        ...state,
        dictionaries: {
          ...state.dictionaries,
          [baseAction.path]: {
            error: action.payload.error,
          },
        },
      };
      return true;
    } else if (action.type === baseAction.name + '.REQUEST_SUCCESS') {
      resultState = {
        ...state,
        dictionaries: {
          ...state.dictionaries,
          [baseAction.path]: {
            data: action.payload.data,
          },
        },
      };
      return true;
    }
  });
  return resultState;
}

export default function getNDFL3Reducer(state = initialState, action) {
  if (action.type === SAGA_ACTIONS.LOADING_START) {
    return {
      ...state,
      loading: true,
    };
  }
  if (action.type === SAGA_ACTIONS.LOADING_FINISH) {
    return {
      ...state,
      loading: false,
    };
  }
  if (action.type === SAGA_ACTIONS.LOADING_NDFL2_START) {
    return {
      ...state,
      loadingNdfl2: true,
    };
  }
  if (action.type === SAGA_ACTIONS.LOADING_NDFL2_FINISH) {
    return {
      ...state,
      loadingNdfl2: false,
    };
  }
  if (action.type === BASE_ACTIONS.GET_3NDFL + '.REQUEST_SUCCESS') {
    return {
      ...state,
      error: false,
      ndfl3Package: action.payload.data,
    };
  }
  /**
   * used to show child tabs, spoilers that submit button was pressed
   * @returns {{type: string}}
   */
  if (action.type === SAGA_ACTIONS.SET_NDFL3_SUBMIT_FAIL) {
    return {
      ...state,
      submitFailedNDFL3: {},
    };
  }

  if (action.type === SAGA_ACTIONS.GET_SOC_DEDUCTIONS_SUCCESS) {
    return {
      ...state,
      ...action.payload,
    };
  }

  if (action.type === SAGA_ACTIONS.GET_STD_DEDUCTIONS_SUCCESS) {
    return {
      ...state,
      ...action.payload,
    };
  }

  if (action.type === SAGA_ACTIONS.GET_MONTH_INCOMES_LOADING) {
    return {
      ...state,
      monthIncomes: { loading: true },
    };
  }
  if (action.type === SAGA_ACTIONS.GET_MONTH_INCOMES_RESULT) {
    return {
      ...state,
      monthIncomes: { loading: false, ...action.payload },
    };
  }

  if (action.type === SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES) {
    return {
      ...state,
      updating3NDFLDraftAttaches: { loading: true, error: null },
    };
  }

  if (action.type === SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES_SUCCESS) {
    return {
      ...state,
      updating3NDFLDraftAttaches: { loading: false, error: null },
    };
  }

  if (action.type === SAGA_ACTIONS.SAVE_NDFL3_DRAFT_ATTACHES_ERROR) {
    return {
      ...state,
      updating3NDFLDraftAttaches: { loading: false, error: action.payload.error },
    };
  }

  return buildReducersForTypicalRequests(state, action);
}
